import React, { useState, useRef } from 'react';
import {
  Box,
  Flex,
  Heading,
  Input,
  Button,
  Text,
  VStack,
  SimpleGrid,
  Image,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useToast,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
} from '@chakra-ui/react';
import {
  CheckCircleIcon,
  ChevronDownIcon,
  Icon,
  SearchIcon,
  WarningIcon,
} from '@chakra-ui/icons';
import { loadStripe } from '@stripe/stripe-js';
import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useBreakpointValue,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import TerminosCondiciones from './TerminosCondiciones';
import AvisoPrivacidad from './AvisoPrivacidad';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TablaLicenciasConDashboard from './TablaLicenciasConDashboard';
import DashboardLicencias from './DashboardLicencias';
import { MdAdd } from 'react-icons/md';
import FloatingAddButton from '../../components/FloatingAddButton';
import ModalSolicitud from './ModalSolicitud';
// import SolicitudLicencia from 'views/ObrasPublicas/SolicitudLicencia';
// import SolicitudZanja from 'views/ObrasPublicas/SolicitudZanja';
// import SolicitudAlineamiento from 'views/ObrasPublicas/SolicitudAlineamiento';
// import SolicitudInfraestructura from 'views/ObrasPublicas/SolicitudInfraestructua';
// import RevisionObraSinLicencia from 'views/ObrasPublicas/RevisionObraSinLicencia';
// import SolicitudUrbanizacion from 'views/ObrasPublicas/SolicitudUrbanizacion';
// import SolicitudFraccionamiento from 'views/ObrasPublicas/SolicitudFraccionamiento';
// import SolicitudDivisionTerrenos from 'views/ObrasPublicas/SolicitudDivisionTerrenos';
// import SolicitudAnuncio from 'views/ObrasPublicas/SolicitudAnuncio';
// import SolicitudPanteon from 'views/ObrasPublicas/SolicitudPanteon';
// import SolicitudConstruccionBase from 'views/ObrasPublicas/SolicitudConstruccionBase';
// import SolicitudDemolicion from 'views/ObrasPublicas/SolicitudDemolicion';
// import SolicitudConstancia from 'views/ObrasPublicas/SolicitudConstancia';
// import RegistroContratista from 'views/ObrasPublicas/RegistroContratista';
const stripePromise = loadStripe(
  'pk_test_51I36nsKFjLyegMZ0PBzyG10mY96fE1LypK6GTZhvkWvzqfRsgFDtpglIoRqLNsXVK7zpTKGXEB2XPnhuE7CqG3hC00mFvPFjhm',
);

interface Tramite {
  ID: string;
  Concepto: string;
  estatus_pago: string;
  Monto: number;
}


const PortalCiudadano: React.FC = () => {
  const {
    isOpen: isSolicitudOpen,
    onOpen: onSolicitudOpen,
    onClose: onSolicitudClose,
  } = useDisclosure();
  
  const [activeModal, setActiveModal] = useState<string | null>(null);
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const [archivos, setArchivos] = useState({ recibo: undefined, fotos: [] });

//   const handleArchivoChange = (e, tipo, multiple = false) => {
//     const files = e.target.files;
//     if (multiple) {
//       setArchivos((prev) => ({ ...prev, [tipo]: Array.from(files) }));
//     } else {
//       setArchivos((prev) => ({ ...prev, [tipo]: files?.[0] }));
//     }
//   };

  const tiposDeTramite = [
    "Temporal",
    "Anual",
    "Renovación",
    "Cancelación",
    "Cambio de giro",
    "Cambio de propietario",
  ];
  const [archivos, setArchivos] = useState({
    solicitud: null,
    recibo: null,
    croquis: null,
    domicilio: null,
    fotos: null,
    dictamen: null,
  });
  
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const {
    isOpen: isDrawerOpen,
    onOpen: onDrawerOpen,
    onClose: onDrawerClose,
  } = useDisclosure();
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const openModal = (section: string) => {
    setActiveModal(section);
    onOpen();
  };

  const handleArchivoChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    tipo: string,
    multiple = false
  ) => {
    const files = e.target.files;
    if (!files) return;
  
    setArchivos((prev) => ({
      ...prev,
      [tipo]: multiple ? Array.from(files) : files[0],
    }));
  };
  
  
  const handleBurgerClick = () => {
    setActiveModal('Menú Principal');
    onOpen(); // Abre el modal
    onDrawerOpen(); // Abre el Drawer
  };

  const closeModal = () => {
    setActiveModal(null);
    onClose();
  };

  const menuItems = [
    'Secretaría',
    'Trámites en Línea',
    'Pagos',
    'Adeudos',
    'Certificaciones',
    'Recibos de Pago',
    'Devoluciones',
  ];

  // Configuración del Carousel
  const settings = {
    dots: true, // Indicadores de posición
    infinite: true, // Carrusel infinito
    speed: 500, // Velocidad de transición
    slidesToShow: 1, // Imágenes mostradas a la vez
    slidesToScroll: 1, // Imágenes que se desplazan
    autoplay: true, // Deslizamiento automático
    autoplaySpeed: 4000, // Tiempo entre cada desplazamiento
  };

  const servicios = [
    {
      title: 'Pago de Predial',
      description: 'Mantén al día tus pagos del impuesto predial.',
      img: 'https://images.unsplash.com/photo-1499916078039-922301b0eb9b?q=80&w=1780&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
    {
      title: 'Pago de Agua',
      description: 'Regulariza tu servicio de agua potable.',
      img: 'https://images.unsplash.com/photo-1542397284385-6010376c5337?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
    {
      title: 'Multas de Tránsito',
      description: 'Consulta y paga tus multas rápidamente.',
      img: 'https://plus.unsplash.com/premium_photo-1687948178367-a1155771044b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
  ];

  const [ineId, setIneId] = useState('');
  const [tramites, setTramites] = useState<Tramite[]>([]);
  const toast = useToast();
  const tramitesRef = useRef<HTMLDivElement>(null);

  const buscarTramites = async () => {
    if (!ineId) {
      toast({
        title: 'Error',
        description: 'Por favor introduce un ID de INE válido.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/Transacciones/rfc/${ineId}`);
      const data = await response.json();

      if (!data || data.length === 0) {
        toast({
          title: 'Sin resultados',
          description: 'No se encontraron trámites para este RFC.',
          status: 'info',
          duration: 3000,
          isClosable: true,
        });
        setTramites([]);
        tramitesRef.current?.scrollIntoView({ behavior: 'smooth' });

      } else {
        setTramites(data);
        tramitesRef.current?.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (error) {
      console.error(error);
      toast({
        title: 'Error',
        description: 'Hubo un problema al consultar la API. Intenta de nuevo.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }


    // const datos = dummyData[ineId];
    // if (!datos) {
    //   toast({
    //     title: 'Sin resultados',
    //     description: 'No se encontraron trámites para este ID del INE.',
    //     status: 'info',
    //     duration: 3000,
    //     isClosable: true,
    //   });
    //   setTramites([]);
    // } else {
    //   setTramites(datos);
    //   // Desplazar automáticamente hacia la sección de trámites
    //   tramitesRef.current?.scrollIntoView({ behavior: 'smooth' });
    // }
  };

  const handlePago = async (tramiteId: string, monto: number) => {
    try {
      const stripe = await stripePromise;
      if (!stripe) {
        throw new Error('Stripe no está disponible.');
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/stripe/create-session`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ tramiteId, monto, ineId }),
        },
      );

      const data = await response.json();
      if (data.error) throw new Error(data.error);

      await stripe.redirectToCheckout({ sessionId: data.sessionId });
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo procesar el pago. Intenta de nuevo.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box pt={79}>
      {/* Header */}
      <Flex
        bg="white"
        color="gray.800"
        py={2}
        px={8}
        justifyContent="space-between"
        alignItems="center"
        borderBottom="2px solid #D6D6D6"
      >
        
      </Flex>

     
      {/* Drawer para Móviles */}
      {isMobile && (
        <Drawer placement="left" onClose={onDrawerClose} isOpen={isDrawerOpen}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader>Navegación</DrawerHeader>
            <DrawerBody>
              {menuItems.map((item) => (
                <Text
                  key={item}
                  fontWeight="bold"
                  my={2}
                  cursor="pointer"
                  _hover={{ color: '#681a2d' }}
                  onClick={() => openModal(item)}
                >
                  {item}
                </Text>
              ))}
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={closeModal} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{activeModal}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
  {tiposDeTramite.includes(activeModal || '') ? (
    <VStack spacing={6} align="stretch">
      <Text fontWeight="bold" fontSize="lg">Datos del Titular</Text>
      <SimpleGrid columns={{ base: 1, md: 1 }} spacing={4}>
        <Input placeholder="Nombre" />
        <Input placeholder="Apellido Paterno" />
        <Input placeholder="Apellido Materno" />
      </SimpleGrid>
      <Input placeholder="INE (número o archivo)" />

      <Text fontWeight="bold" fontSize="lg">Documentación Requerida</Text>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
      <Box>
  <Text fontSize="sm" mb={1}>Recibo Predial / Agua</Text>
  <Input type="file" accept=".pdf,.jpg,.png"
    onChange={(e) => handleArchivoChange(e, 'recibo')}
  />
  {archivos.recibo && (
    <Text fontSize="xs" mt={1} color="gray.600">
      Archivo seleccionado: {archivos.recibo.name}
    </Text>
  )}
</Box>

<Box>
  <Text fontSize="sm" mb={1}>Fotografías del Establecimiento</Text>
  <Input
    type="file"
    multiple
    accept=".jpg,.png"
    onChange={(e) => handleArchivoChange(e, 'fotos', true)}
  />
  {archivos.fotos && Array.isArray(archivos.fotos) && (
    <Box mt={1}>
      {archivos.fotos.map((file, index) => (
        <Text key={index} fontSize="xs" color="gray.600">
          {file.name}
        </Text>
      ))}
    </Box>
  )}
</Box>


      </SimpleGrid>

      <Button colorScheme="red" mt={6} alignSelf="flex-end">
        Enviar solicitud
      </Button>
    </VStack>
  ) : (
    <Text>Contenido de la sección: {activeModal}</Text>
  )}
</ModalBody>


          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={closeModal}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

     <DashboardLicencias></DashboardLicencias>
     <TablaLicenciasConDashboard></TablaLicenciasConDashboard>
 
    <FloatingAddButton 
      text="Nueva Licencia" 
      onClick={onOpen} 
    />

{/* <ModalSolicitud
        isOpen={isOpen}
        onClose={onClose}
        archivos={archivos}
        handleArchivoChange={handleArchivoChange}
      />  */}

      <ModalSolicitud
  isOpen={isOpen}
        onClose={onClose}
  archivos={{}} // o estado si lo tienes
  handleArchivoChange={() => {}} // función real si ya la manejas
  modo="new"
  data={undefined}
/>

     
    </Box>

  
  );
};

export default PortalCiudadano;
function onDrawerOpen() {
  throw new Error('Function not implemented.');
}
